import React, { memo, useMemo, Fragment } from 'react';
import { isEmpty, map } from 'lodash';
/* Utils */
import { getGlobalSearchLinks } from 'site-modules/shared/utils/inventory/global-search-links';
/* Constants */
import {
  LINK_COMPONENTS,
  GLOBAL_SEARCH_LINKS_COMPONENTS_MAP,
} from 'site-modules/shared/constants/global-search/global-search';
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';
/* Components */
import { SpeculationRule } from 'site-modules/shared/components/speculation-rule/speculation-rule';

const PRERENDER_LINKS_NUM = 1;

export const GlobalSearchLinks = memo(props => {
  const { fastMatcherData, query } = props;
  const globalSearchLinks = useMemo(() => getGlobalSearchLinks({ fastMatcherData, query }), [fastMatcherData, query]);

  const pricingReviewsLinks = globalSearchLinks.pricingReviewsLinks?.links;
  const speculationLinks = useMemo(
    () => ({
      prerender: pricingReviewsLinks?.slice(0, PRERENDER_LINKS_NUM)?.map(({ url }) => url),
      prefetch: pricingReviewsLinks?.slice(PRERENDER_LINKS_NUM)?.map(({ url }) => url),
    }),
    [pricingReviewsLinks]
  );

  return (
    <Fragment>
      <ul className="list-unstyled mb-0">
        {map(
          globalSearchLinks,
          ({ links, icon, label }) =>
            !isEmpty(links) &&
            links.map(linkConfig => {
              const { title, url, linkType = LINK_COMPONENTS.BASE } = linkConfig;
              const Component = GLOBAL_SEARCH_LINKS_COMPONENTS_MAP[linkType]?.component;
              return (
                <li key={`${title}-${url}`}>
                  <Component {...props} query={query} icon={icon} label={label} {...linkConfig} />
                </li>
              );
            })
        )}
      </ul>
      {!!speculationLinks.prerender?.length && (
        <SpeculationRule speculationTimeout={750} urls={speculationLinks.prerender} />
      )}
      {!!speculationLinks.prefetch?.length && (
        <SpeculationRule action="prefetch" speculationTimeout={1250} urls={speculationLinks.prefetch} />
      )}
    </Fragment>
  );
});

GlobalSearchLinks.displayName = 'GlobalSearchLinks';

GlobalSearchLinks.propTypes = {
  ...GlobalSearchLinkPropTypes,
};

GlobalSearchLinks.defaultProps = {
  ...GlobalSearchLinkDefaultProps,
};
